import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const panelService = {
    getAll,
    show,
};

const MODULE = {
    PANEL: 'panels',
};

const API_URL = API.BASE_URL_API + '/v1/fe';

export function getAll(filter) {
    const request = {
        params: {
            location: filter?.location,
            panel_type: filter?.panelType,
            is_active: filter?.isActive,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.PANEL}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PANEL}/${uuid}`);
}